"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiEndpoints = void 0;
const BASE_URL = "https://analytics.us.algolia.com";
class ApiEndpoints {
}
exports.ApiEndpoints = ApiEndpoints;
ApiEndpoints.POPULAR_SEARCH = BASE_URL + "/2/searches";
